import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Music2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative z-10 bg-neutral-50 border-t border-neutral-200">
      <div className="container mx-auto px-6 py-12">
        <div className="flex flex-col items-center gap-6">
          <img
            src="/s-mark.png"
            alt="Soulboard"
            className="h-16 w-auto"
            style={{ mixBlendMode: 'multiply' }}
            data-testid="footer-logo"
          />
          
          <div className="flex gap-6">
            <a 
              href="#" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
              data-testid="footer-instagram-link"
            >
              <Instagram size={20} />
            </a>
            <a 
              href="https://www.tiktok.com/@melindamarchsecond" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="TikTok"
              data-testid="footer-tiktok-link"
            >
              <Music2 size={20} />
            </a>
          </div>

          <p className="text-sm text-neutral-600 text-center max-w-2xl">
            {t('footerDisclaimer')}
          </p>

          <Link
            to="/terms"
            className="text-xs text-neutral-500 underline underline-offset-4 hover:text-neutral-800 transition-colors"
            data-testid="footer-terms-link"
          >
            {t('termsLinkLabel')}
          </Link>

          <p className="text-xs text-neutral-500">
            © {new Date().getFullYear()} Soulboard. {t('allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
